/*
 * The tenant key sent to marvin-core on every query (`tmc`). VUE_APP_TMC names it
 * directly, so a deployment needs no compiled theme package to identify its
 * tenant (talma). Without it, the key is inferred from the theme package name
 * exactly as before, so gdg / omega / meon builds are unchanged.
 */
const THEME_TMC = {
  'marvin-gdg-fe': 'gdg',
  'marvin-omega-fe': 'omega',
  'marvin-meon-fe': 'meon'
};

function getContextTMC() {
  if (process.env.VUE_APP_TMC) {
    return process.env.VUE_APP_TMC;
  }
  return THEME_TMC[process.env.VUE_APP_THEME];
}

export { getContextTMC };
